"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M6.393 3.52a2.49 2.49 0 0 1 2.12 1.174L12 11.852V4.02a.5.5 0 0 1 .5-.5h9c.737 0 1.96.753 2.354 1.146A.504.504 0 0 1 24 5.02v1.5a.5.5 0 0 1-.276.447L23 7.329v3.382l.724.362a.5.5 0 0 1 .276.447v4.5a2.504 2.504 0 0 1-2.042 2.458A2.504 2.504 0 0 1 19.5 20.52a2.504 2.504 0 0 1-2.45-2H6.95a2.504 2.504 0 0 1-2.45 2 2.504 2.504 0 0 1-2.45-2H.5a.503.503 0 0 1-.485-.621l1-4a.502.502 0 0 1 .486-.379h5.327L5.001 7.427V9.02c0 .827-.673 1.5-1.5 1.5S2 9.847 2 9.02a.5.5 0 0 1 .992-.09L3 9.02a.5.5 0 0 0 1 0v-5a.5.5 0 0 1 .42-.494l.04-.004 1.932-.002Zm-1.893 13c-.827 0-1.5.673-1.5 1.5s.673 1.5 1.5 1.5 1.5-.673 1.5-1.5-.673-1.5-1.5-1.5Zm15 0c-.827 0-1.5.673-1.5 1.5s.673 1.5 1.5 1.5 1.5-.673 1.5-1.5-.673-1.5-1.5-1.5Zm2-12H13v9.473a.5.5 0 0 1-.5.527H1.892l-.75 3h.908c.232-1.14 1.242-2 2.45-2 1.208 0 2.218.86 2.45 2h10.1c.232-1.14 1.242-2 2.45-2 1.184 0 2.178.828 2.435 1.934A1.5 1.5 0 0 0 23 16.02v-4.191l-.724-.362A.503.503 0 0 1 22 11.02v-4a.5.5 0 0 1 .276-.447L23 6.211v-.965c-.407-.319-1.193-.726-1.5-.726Zm-4 8a.5.5 0 0 1 0 1h-1a.5.5 0 0 1 0-1h1Zm-11.107-8h-1.22l2.7 9h3.83L7.64 5.178c-.252-.394-.728-.658-1.248-.658Zm10.107 2a.5.5 0 0 1 .5.5v3.5h3.5a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 .5-.5Z",
    clipRule: "evenodd"
  })]
});